export default __webpack_public_path__ + "static/golf-tournament-01-85de5f0be0132b87e5722f4aa0eb5b2d.webp";